import { APPLICANT_CREDIT_CHECK_BAND } from '../../../../../RentalPortalApplicant'

export const QA_NAME_APPLICANT_CREDIT_CHECK_VERDICT =
  'applicantCreditCheckVerdict'

export const QA_NAME_APPLICANT_CREDIT_CHECK_VERDICT_NATIVE_VALUE =
  'applicantCreditCheckVerdictNativeValue'

export const QA_NAME_APPLICANT_CREDIT_CHECK_VERDICT_ISSUED_AT =
  'applicantCreditCheckVerdictIssuedAt'

export const QA_NAME_APPLICANT_CREDIT_CHECK_VERDICT_EXPIRES_AT =
  'applicantCreditCheckVerdictExpiresAt'

export const QA_NAME_APPLICANT_CREDIT_CHECK_VERDICT_CODE =
  'applicantCreditCheckVerdictCode'

export const QA_NAME_APPLICANT_CREDIT_CHECK_VERDICT_VERIFIED =
  'applicantCreditCheckVerdictVerified'

export const QA_NAME_APPLICANT_CREDIT_CHECK_VERDICT_PROVIDER =
  'applicantCreditCheckVerdictProvider'

export const QA_NAME_APPLICANT_CREDIT_CHECK_VERDICT_SAVE =
  'applicantCreditCheckVerdictSave'

export const QA_NAME_APPLICANT_CREDIT_CHECK_VERDICT_CORRECTION =
  'applicantCreditCheckVerdictCorrection'

export const QA_NAME_APPLICANT_CREDIT_CHECK_VERDICT_DISCARD =
  'applicantCreditCheckVerdictDiscard'

export const QA_NAME_APPLICANT_CREDIT_CHECK_VERDICT_EXTRACTED =
  'applicantCreditCheckVerdictExtracted'

export const APPLICANT_CREDIT_CHECK_VERDICT_FIELD_NAME_BAND = 'normalised_band'

export const APPLICANT_CREDIT_CHECK_VERDICT_FIELD_NAME_NATIVE_VALUE =
  'native_value'

export const APPLICANT_CREDIT_CHECK_VERDICT_FIELD_NAME_ISSUED_AT = 'issued_at'

export const APPLICANT_CREDIT_CHECK_VERDICT_FIELD_NAME_EXPIRES_AT = 'expires_at'

export const APPLICANT_CREDIT_CHECK_VERDICT_FIELD_NAME_CODE =
  'verification_code'

export const APPLICANT_CREDIT_CHECK_VERDICT_FIELD_NAME_VERIFIED = 'is_verified'

export const APPLICANT_CREDIT_CHECK_VERDICT_ROLE_VALUE_KEY = {
  expected: 'RentalPortal.ApplicantCreditCheckVerdictRoleExpectedKey',
  supplementary: 'RentalPortal.ApplicantCreditCheckVerdictRoleSupplementaryKey',
}

export const APPLICANT_CREDIT_CHECK_VERDICT_DISCARD_CONFIRMATION_PROPS = {
  qaName: QA_NAME_APPLICANT_CREDIT_CHECK_VERDICT_DISCARD,
  title: 'RentalPortal.ListingProfileBlockDiscardTitleKey',
}

export const APPLICANT_CREDIT_CHECK_VERDICT_BAND_ORDER = [
  APPLICANT_CREDIT_CHECK_BAND.positive,
  APPLICANT_CREDIT_CHECK_BAND.neutral,
  APPLICANT_CREDIT_CHECK_BAND.negative,
  APPLICANT_CREDIT_CHECK_BAND.inconclusive,
]

export const APPLICANT_CREDIT_CHECK_VERDICT_NATIVE_VALUE_MAX_LENGTH = 64

export const APPLICANT_CREDIT_CHECK_VERDICT_CODE_MAX_LENGTH = 64
